"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputBottomRow = void 0;
var css_1 = require("@emotion/css");
var react_1 = __importDefault(require("react"));
var Error_1 = require("./Error");
var Guidance_1 = require("./Guidance");
var Units_1 = require("./Units");
var bottomRowStyles = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  padding-top: 3px;\n  gap: 16px;\n"], ["\n  display: flex;\n  padding-top: 3px;\n  gap: 16px;\n"])));
var InputBottomRow = function (_a) {
    var testId = _a.testId, error = _a.error, id = _a.id, guidance = _a.guidance, units = _a.units, isDisabled = _a.isDisabled;
    return error || guidance || units ? (react_1.default.createElement("div", { className: bottomRowStyles, "data-testid": testId && "".concat(testId, "-bottom-row") },
        !error && react_1.default.createElement(Guidance_1.Guidance, { id: id, guidance: guidance, testId: testId }),
        react_1.default.createElement(Error_1.ErrorInput, { id: id, error: error, testId: testId }),
        react_1.default.createElement(Units_1.Units, { units: units, testId: testId, isDisabled: isDisabled }))) : null;
};
exports.InputBottomRow = InputBottomRow;
var templateObject_1;
